import {Box} from "@mui/material";
import {useAppContext} from "@/contexts/AppContext.tsx";

export default function MainHeadingActions({children}: any) {
    const {uiVisual} = useAppContext();

    return (
        <Box sx={{
            height: 50,
            padding: 1,
            borderBottom: uiVisual === 'classic' ? '1px solid #e0e0e0' : '1px solid #ECF4FF',
            bgcolor: uiVisual === 'classic' ? 'white' : '#F9FAFF'
        }}>
            {children}
        </Box>
    )
}